import { CustomLink } from "@/components";
import { useMenu } from "@/services/context/MobileMenuContext";
import { cn } from "@/services/hooks/utils";
import { useRouterState } from "@tanstack/react-router";
import { getActiveUserNavHref, navGroups, userNavItems } from "./userNavItems";

export const MenuNav = () => {
    const { closeMenu } = useMenu();
    const pathname = useRouterState({
        select: (state) => state.location.pathname,
    });
    const activeHref = getActiveUserNavHref(pathname);

    return (
        <nav className="mt-4 space-y-5" aria-label="Navegación de usuario">
            {navGroups.map((group) => {
                const items = userNavItems.filter(
                    (item) => item.group === group,
                );
                if (items.length === 0) return null;

                return (
                    <div key={group} className="space-y-1">
                        <p className="px-3 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
                            {group}
                        </p>
                        <ul className="space-y-1">
                            {items.map((item) => {
                                const Icon = item.icon;
                                const isActive = activeHref === item.href;

                                return (
                                    <li key={item.href}>
                                        <CustomLink
                                            to={item.href as never}
                                            onClick={closeMenu}
                                            className={cn(
                                                "flex min-h-11 items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                                                "text-muted-foreground hover:bg-primary/10 hover:text-primary",
                                                isActive &&
                                                    "bg-primary/10 text-primary",
                                            )}
                                        >
                                            <Icon className="h-5 w-5 shrink-0" />
                                            <span>{item.title}</span>
                                        </CustomLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                );
            })}
        </nav>
    );
};
